export { initGa4, GA4_TOKEN }

const GA4_TOKEN = 'G-HMXQ8V408Y'

// see: https://developers.google.com/analytics/devguides/migration/ua/analyticsjs-to-gtagjs
const initGa4 = (token = GA4_TOKEN) => {
  // Ensure gtag function exists (may be called before deferred script loads)
  // Uses Google's canonical snippet pattern: push arguments object (array-like)
  window.gtag = window.gtag || function() {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', token)
}